var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"video"},[_c('video',{attrs:{"src":_vm.downloadURLImg+'6b7bd63fef18153eac76cfd8ebc6d31f_222187393_mp4',"controls":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }